import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { calendar_v3, google } from 'googleapis';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthQuery } from 'src/app/modules/auth/state/auth.query';
import { AuthState, AuthStore } from 'src/app/modules/auth/state/auth.store';
import { AttendeeModel } from 'src/app/modules/shared/models/attendee.model';
import { CopyEventModel } from 'src/app/modules/shared/models/copyevent.model';
import { EventModel } from 'src/app/modules/shared/models/event.model';
import { Converters } from 'src/app/modules/shared/utils/converters.utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  constructor(private http: HttpClient, private authQuery: AuthQuery) { }

  getEvents(from: Date, to: Date, calendarId = 'primary'): Observable<Array<calendar_v3.Schema$Event>> {
    return this.http.get<any>(`${environment.api.url}/api/v1/calendar/get_events?calendarId=${calendarId}&from=${from.toISOString()}&to=${to.toISOString()}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  searchEvents(term: string, calendarId = 'primary'): Observable<Array<calendar_v3.Schema$Event>> {
    return this.http.get<any>(`${environment.api.url}/api/v1/calendar/search_events?calendarId=${calendarId}&term=${term}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  getCalendars(): Observable<Array<calendar_v3.Schema$Calendar>> {
    return this.http.get<any>(`${environment.api.url}/api/v1/calendar/get_calendars`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  logout(): any {
    return this.http.post<any>(`${environment.api.url}/api/v1/auth/delete_oauth_credential`, {}, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  insertEvent(event: EventModel): Observable<calendar_v3.Schema$Event> {
    if (!event.dataOraInizio && event.dataInizio && event.oraInizio) {
      event.dataOraInizio = Converters.fromNgbDateStructToDateWithTimes(event.dataInizio, event.oraInizio);
    }
    if (!event.dataOraFine && event.oraFine) {
      event.dataOraFine = Converters.fromNgbDateStructToDateWithTimes(event.dataInizio, event.oraFine);
    }

    return this.http.post<any>(`${environment.api.url}/api/v1/calendar/insert_event`, event, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

   // TODO this one and the previous are the same. refactor!
  patchEvent(event: EventModel): Observable<calendar_v3.Schema$Event> {
    if (event.dataInizio && event.oraInizio) {
      event.dataOraInizio = Converters.fromNgbDateStructToDateWithTimes(event.dataInizio, event.oraInizio);
    }
    if (event.dataFine && event.oraFine) {
      event.dataOraFine = Converters.fromNgbDateStructToDateWithTimes(event.dataInizio, event.oraFine);
    }

    return this.http.patch<any>(`${environment.api.url}/api/v1/calendar/patch_event`, event, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  deleteEvent(event: EventModel): Observable<calendar_v3.Schema$Event> {
    return this.http.delete<any>(`${environment.api.url}/api/v1/calendar/delete_event/?calendarId=${event.calendarId}&eventId=${event.id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  copyEventTo(event: EventModel, toCalendarId: string): Observable<calendar_v3.Schema$Event> {
    const copyEvent = new CopyEventModel();
    copyEvent.eventId = event.id;
    copyEvent.fromCalendarId = event.calendarId;
    copyEvent.toCalendarId = toCalendarId;
    return this.http.post<any>(`${environment.api.url}/api/v1/calendar/copy_event`, copyEvent, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }

  oauthcallback(state: any, code: any, scope: any): Observable<any>{
    return this.http.get<any>(`${environment.api.url}/api/v1/auth/oauth2_callback?state=${state}&code=${code}&scope=${scope}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((events) => {
      }),
      catchError((error: HttpErrorResponse, obs) => {
        throw error;
      })
    );
  }
}
